import clsx from "clsx";
import React from "react";
import { LoadingButton, LoadingButtonProps } from "../../../../common/components/LoadingButton";
import { Disableable } from "../../Disableable";
import { Button } from "@truevault/aquilo";
import { ButtonVariant } from "@truevault/aquilo/src/components/utils/types";

export function SurveyButton({
  className,
  useNewDesign,
  newDesignButtonVariant,
  disabledSelected,
  ...rest
}: LoadingButtonProps & {
  useNewDesign?: boolean;
  newDesignButtonVariant?: ButtonVariant;
  disabledSelected?: boolean;
}) {
  // When button is disabled but should appear selected, apply special styling
  const isDisabledSelected = disabledSelected && rest.disabled;

  if (useNewDesign) {
    // When disabled but should appear selected, show as "selected" color with reduced opacity
    const showAsSelected = isDisabledSelected || (rest.color === "primary" && !rest.disabled);

    return (
      <div style={isDisabledSelected ? { opacity: 0.4 } : undefined}>
        <Button
          color={showAsSelected ? "selected" : "tertiary"}
          onClick={rest.onClick}
          disabled={rest.disabled}
          variant={newDesignButtonVariant}
          width="full"
        >
          {rest.children}
        </Button>
      </div>
    );
  }

  const buttonClassName = clsx(
    "min-width-192 h-48 mr-md",
    className,
    isDisabledSelected && "survey-button--disabled-selected",
  );

  // Style for disabled but selected buttons - shows primary color at 40% opacity
  const disabledSelectedStyle = isDisabledSelected
    ? {
        opacity: 0.4,
        backgroundColor: "#1976d2",
        color: "white",
        borderColor: "#1976d2",
      }
    : undefined;

  if (rest.disabledTooltip) {
    return (
      <div className="d-inline-block">
        <Disableable disabled={rest.disabled} disabledTooltip={rest.disabledTooltip}>
          <LoadingButton
            variant="outlined"
            {...rest}
            className={buttonClassName}
            style={disabledSelectedStyle}
          />
        </Disableable>
      </div>
    );
  } else {
    return (
      <LoadingButton
        variant="outlined"
        {...rest}
        className={buttonClassName}
        style={disabledSelectedStyle}
      />
    );
  }
}
